/* src/app/ship/ship-info/ship-info.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-info {
  width: 100%;
}
.ship-info .select-wrapper {
  position: relative;
}
.ship-info .package-dimension {
  margin-top: -1.5rem;
}
.ship-info .package-dimension-label {
  display: inline-block !important;
  position: relative;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.58);
}
.ship-info .dimensions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
  font-size: 0.8rem;
}
.ship-info .dimensions ::ng-deep {
}
.ship-info .dimensions ::ng-deep .mat-mdc-form-field {
  margin-right: 2rem;
}
.ship-info .dimensions ::ng-deep .mat-mdc-form-field .mat-form-field-infix {
  width: auto;
  border-top-width: 0;
}
.ship-info .dimensions ::ng-deep .mat-form-field-label {
  top: 3.75rem;
}
.ship-info .dimensions ::ng-deep .mat-mdc-form-field-error {
  margin-top: 0.75rem;
}
.ship-info .insurnce-value {
  position: relative;
}
.ship-info .insurnce-value + img {
  position: absolute;
  top: 0.4rem;
  right: 0rem;
}
:host {
  width: 100%;
}
/*# sourceMappingURL=ship-info.component.css.map */
